import { Pipe, PipeTransform } from "@angular/core";
import { absoluteUrl } from "../support/navigation";

@Pipe({
  name: "absoluteUrl",
  standalone: false
})
export class AbsoluteUrlPipe implements PipeTransform {
  transform(path: string): string {
    return absoluteUrl(path);
  }
}
